import { Color } from "three";
import { ColorDictionary } from "./utils/typeDefinitions";



// Keep in sync with ProductTypeEnum in API
export enum ElementTypeEnum {
    NotDefined = "NotDefined",
    Wall = "Wall",
    Door = "Door",
    Window = "Window",
    Fixture = "Fixture",
    Covering = "Covering",
    Space = "Space",
    Storey = "Storey",
    Building = "Building"
}

export const getElementTypeFromString = (input: string): ElementTypeEnum => {
    const normalizedInput = input.trim().toLowerCase();

    // Loop through enum values
    for (const value of Object.values(ElementTypeEnum)) {
        if (value.toLowerCase() === normalizedInput) {
            return value as ElementTypeEnum;
        }
    }

    return ElementTypeEnum.NotDefined; // or throw an error if undefined is not acceptable
}

